import { io } from 'socket.io-client';

/* API + Socket.io host. Cloudflare Pages / any static host: set
   REACT_APP_API_URL at build time (Pages → Settings → Environment variables).
   Dev: defaults to local server. Prod without env: legacy Render fallback. */
const trimSlash = (s) => (typeof s === 'string' ? s.replace(/\/$/, '') : '');

const URL =
  trimSlash(process.env.REACT_APP_API_URL) ||
  (process.env.NODE_ENV === 'production'
    ? 'https://movie-mayhem.onrender.com'
    : 'http://localhost:3010');

export const API_URL = URL;

const STORAGE_TOKEN_KEY = 'movie-mayhem.token';
const STORAGE_USERNAME_KEY = 'movie-mayhem.username';

export const getStoredAuth = () => ({
  token: localStorage.getItem(STORAGE_TOKEN_KEY) || null,
  username: localStorage.getItem(STORAGE_USERNAME_KEY) || null,
});

export const setStoredAuth = ({ token, username }) => {
  if (token) localStorage.setItem(STORAGE_TOKEN_KEY, token);
  else localStorage.removeItem(STORAGE_TOKEN_KEY);
  if (username) localStorage.setItem(STORAGE_USERNAME_KEY, username);
  else localStorage.removeItem(STORAGE_USERNAME_KEY);
};

export const clearStoredAuth = () => setStoredAuth({ token: null, username: null });

// `auth` is a function so socket.io re-reads localStorage on every (re)connect
// attempt - useful when the token is set after the initial socket creation.
export const socket = io(URL, {
  withCredentials: true,
  auth: (cb) => {
    const token = localStorage.getItem(STORAGE_TOKEN_KEY) || null;
    cb({ token });
  },
  extraHeaders: {
    "Access-Control-Allow-Origin": "*"
  }
});

// Reconnect with an updated token so the server can associate the username
// with this socket from the handshake onwards.
export const refreshSocketAuth = () => {
  if (socket.connected) {
    socket.disconnect();
  }
  socket.connect();
};
